function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-38"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.83,
    y: 398.49,
    width: 53.07,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.56,
    y: 395.36,
    width: 58.66,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.2,
    y: 393.92,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.47,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.46,
    y: 390.89,
    width: 15.44,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 54.2,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.71,
    y: 248.91,
    width: 10.51,
    height: 125.03,
    transform: "translate(543.93 622.85) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.75,
    y: 373.94,
    width: 208.44,
    height: 8.33,
    transform: "translate(337.93 756.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.71,
    y: 248.91,
    width: 206,
    height: 125.03,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.18,
    y: 241.03,
    width: 10.86,
    height: 7.88,
    transform: "translate(549.23 489.94) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.89,
    y: 241.03,
    width: 211.3,
    height: 7.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.97,
    y: 258.61,
    width: 189.47,
    height: 43.13,
    rx: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.97,
    y: 314.62,
    width: 189.47,
    height: 43.13,
    rx: 7.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.16,
    y: 257.3,
    width: 93.1,
    height: 5.91,
    rx: 1.77,
    transform: "translate(327.42 520.52) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.16,
    y: 313.31,
    width: 93.1,
    height: 5.91,
    rx: 1.77,
    transform: "translate(327.42 632.54) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.49,
    y: 289.93,
    width: 31.7,
    height: 6.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.2,
    y: 175,
    width: 5.85,
    height: 207.4,
    transform: "translate(788.25 557.4) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.93,
    y: 289.93,
    width: 44.56,
    height: 6.06,
    transform: "translate(786.43 585.91) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.49,
    y: 345.73,
    width: 31.7,
    height: 6.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.93,
    y: 345.73,
    width: 44.56,
    height: 6.06,
    transform: "translate(786.43 697.52) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.49,
    y: 178.32,
    width: 31.7,
    height: 6.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.93,
    y: 178.32,
    width: 44.56,
    height: 6.06,
    transform: "translate(786.43 362.7) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.49,
    y: 234.12,
    width: 31.7,
    height: 6.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.93,
    y: 234.12,
    width: 44.56,
    height: 6.06,
    transform: "translate(786.43 474.31) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.76,
    y: 175,
    width: 5.85,
    height: 207.4,
    transform: "translate(877.37 557.4) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.64,
    y: 175,
    width: 5.85,
    height: 207.4,
    transform: "translate(825.13 557.4) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.93,
    y: 175,
    width: 5.85,
    height: 207.4,
    transform: "translate(747.72 557.4) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.88,
    y: 83.37,
    width: 264.2,
    height: 140.27,
    transform: "translate(439.97 307.01) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.22,
    y: 83.37,
    width: 267.1,
    height: 140.27,
    transform: "translate(429.54 307.01) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.69,
    y: 29.53,
    width: 118.16,
    height: 247.96,
    transform: "translate(368.27 -61.27) rotate(90)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-38"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-38",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.82,264.22H110.54a3.34,3.34,0,0,1-3.33-3.33h0a3.34,3.34,0,0,1,3.33-3.33H387.82a3.34,3.34,0,0,1,3.33,3.33h0A3.34,3.34,0,0,1,387.82,264.22Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.82,264.22H322.91a3.34,3.34,0,0,1-3.33-3.33h0a3.34,3.34,0,0,1,3.33-3.33h64.91a3.34,3.34,0,0,1,3.33,3.33h0A3.34,3.34,0,0,1,387.82,264.22Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.53,
    y: 272.57,
    width: 213.25,
    height: 23.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.53,
    y: 272.57,
    width: 213.25,
    height: 23.21,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.68 411.62 384.06 411.62 383.8 264.22 374.96 264.22 377.68 411.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.68 411.62 384.06 411.62 383.8 264.22 374.96 264.22 377.68 411.62",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.88 411.62 312.49 411.62 326.93 264.22 335.77 264.22 318.88 411.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.88 411.62 312.49 411.62 326.93 264.22 335.77 264.22 318.88 411.62",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.31 411.62 171.69 411.62 171.43 264.22 162.59 264.22 165.31 411.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.31 411.62 171.69 411.62 171.43 264.22 162.59 264.22 165.31 411.62",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.51 411.62 100.12 411.62 114.56 264.22 123.4 264.22 106.51 411.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.51 411.62 100.12 411.62 114.56 264.22 123.4 264.22 106.51 411.62",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.11 257.56 271.39 257.56 265.5 228.78 280.22 228.78 286.11 257.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.64,251.63H241.78a3.59,3.59,0,0,1-3.62-3.85l2.44-40.43a4.15,4.15,0,0,1,4.08-3.85h63.87a3.6,3.6,0,0,1,3.62,3.85l-2.44,40.43A4.16,4.16,0,0,1,305.64,251.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,251.63H240.78a3.59,3.59,0,0,1-3.62-3.85l2.44-40.43a4.15,4.15,0,0,1,4.08-3.85h63.87a3.6,3.6,0,0,1,3.62,3.85l-2.44,40.43A4.16,4.16,0,0,1,304.64,251.63Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.77,249.63a1.64,1.64,0,0,1-1.19-.5,1.67,1.67,0,0,1-.43-1.23l2.44-40.43a2.15,2.15,0,0,1,2.09-2h63.87a1.6,1.6,0,0,1,1.62,1.73l-2.44,40.43a2.14,2.14,0,0,1-2.09,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.82 203.5 272.97 217.71 285.29 203.5 268.82 203.5",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.55,169c.1.77.58,1.35,1.09,1.31s.83-.7.73-1.47-.58-1.35-1.08-1.31S169.46,168.25,169.55,169Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.39,170.15a24.53,24.53,0,0,0,3.46,5.55c-1.1,1.11-3.11.66-3.11.66Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,166.07a.63.63,0,0,1-.23,0,.47.47,0,0,1-.25-.6,4.41,4.41,0,0,1,3.1-2.69.45.45,0,0,1,.52.37.46.46,0,0,1-.37.53,3.41,3.41,0,0,0-2.4,2.14A.48.48,0,0,1,167,166.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.89,181.07l6,4.6,8.19,6.27a8.48,8.48,0,0,0-.8,3c-.29,2.3-.58,4,4.53,5.41a2.91,2.91,0,0,1,2.18,2.27c.2,1.36-.63,3-5.35,3.81a21.69,21.69,0,0,1-13.33-2.27c-2-1-2-2.2-1.16-4.23C149.67,194.16,148.45,186.8,146.89,181.07Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,201.75a41.67,41.67,0,0,0,2.84-6.92s15.2-.83,20.22.67,8.14,8,8.14,8Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.36,213.06c-.37,1.12-.78,2.49-1.17,3.75l-1.13,3.9c-.7,2.6-1.38,5.21-1.91,7.81a74.52,74.52,0,0,0-1.29,7.7,36.54,36.54,0,0,0-.22,7.17,16.17,16.17,0,0,0,.46,3c.06.2.11.42.18.61l.2.54v0s0,0,0,0a2.54,2.54,0,0,0-.16-.28,4.79,4.79,0,0,0-.33-.42,2.39,2.39,0,0,0-.44-.41c-.2-.14-.23-.12-.19-.07a4.91,4.91,0,0,0,.94.53c.45.2,1,.4,1.55.59,1.13.38,2.38.73,3.67,1.07,5.16,1.3,10.79,2.31,16.28,3.48l-.18,6.93a88.26,88.26,0,0,1-8.84.73,85,85,0,0,1-9-.15,43.22,43.22,0,0,1-4.73-.58c-.82-.15-1.67-.32-2.57-.57a15.74,15.74,0,0,1-3-1.11,10.76,10.76,0,0,1-2-1.25,9.1,9.1,0,0,1-1.21-1.16,9.39,9.39,0,0,1-.64-.85c-.1-.17-.21-.34-.3-.51l-.13-.24-.69-1.41c-.21-.47-.38-.93-.56-1.4a28.11,28.11,0,0,1-1.36-5.4c-1-6.95-.21-13.15.83-19.18.56-3,1.22-6,2-8.85.4-1.45.82-2.9,1.27-4.33s.93-2.81,1.51-4.38Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.11,200.51c9.45-2.5,15.06,5.24,11.86,18s-4.27,13.24-4.27,13.24l-19.49-3.25C127.61,216,127.42,203.06,137.11,200.51Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.64,249.26l-1.47-.13c-4.18,0-4.9,1.14-7.47,3.53l-1,5.26c6.75,3.45,10.37-.34,10.38-.34h6.25l-2.2-5A5.5,5.5,0,0,0,167.64,249.26Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,171.12c1.7,9.11,2.23,14.53,7.45,18.6,7.84,6.11,18.64.3,19.7-9.18.95-8.53-2-22-11.42-24.39A12.88,12.88,0,0,0,144.31,171.12Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36,174.3c6.5-.52,4.6-7.37,2.59-8.8,3.05-1.16,5.15-6,2.22-9.32,1.72-4.49-3.2-9.9-11.83-9.09-6.3.58-7,3.91-7,3.91s-7.55-.79-10.69,5.44c-2.68,5.34.57,8.19.57,8.19s-5.64,1.64-4.08,9c1.66,7.94,7.76,6.1,7.76,6.1s-1.37,7.28,6.88,7.38c7.13.09,7.22-5.25,7.22-5.25S165.24,181,162.36,174.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.52,174.83a8.47,8.47,0,0,0,4,4.54c2.38,1.22,4.2-1.31,3.78-3.91-.38-2.33-2.41-5.32-4.92-5.46S156.63,172.41,157.52,174.83Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.47 400.17 263.36 396.56 257.08 375.21 248.19 378.81 254.47 400.17",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.24 389.17 260.22 385.87 257.08 375.21 248.19 378.81 251.24 389.17",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.59,393l-10.17,3.53a.68.68,0,0,0-.45.85l2.3,8.22a1.71,1.71,0,0,0,2.15,1.06c3.51-1.3,4.93-2,9.27-3.88a137,137,0,0,0,12.52-6c3.39-2,1.35-5.41-.3-4.85-3.91,1.32-10.32,2.18-13.57,1.06A2.69,2.69,0,0,0,262.59,393Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.07,277S250.26,283,252,302.33c3.5,39.33,8.87,77.25,8.87,77.25l-13.67,5s-16.73-43.2-16.51-74c-19.38-5.47-70.34,2.56-78.67-12.39-7.36-13.2-.9-22.68-.9-22.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.18 387.69 263.2 381.94 262.46 374.19 243.27 380.37 246.18 387.69",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.34,393.41a11.61,11.61,0,0,1-2.52.51.22.22,0,0,1-.22-.11.23.23,0,0,1,0-.24c.22-.3,2.18-2.94,3.43-2.9a.87.87,0,0,1,.7.43,1.23,1.23,0,0,1,.13,1.24A2.6,2.6,0,0,1,266.34,393.41Zm-2,0c1.73-.24,2.91-.7,3.18-1.27a.78.78,0,0,0-.11-.8.39.39,0,0,0-.34-.22C266.35,391.09,265.11,392.38,264.29,393.41Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.87,393.91a.2.2,0,0,1-.11,0,.23.23,0,0,1-.17-.13c0-.11-1.15-2.64-.55-3.84a1.13,1.13,0,0,1,.79-.6.85.85,0,0,1,1,.37c.55.92-.14,3.27-.85,4.12A.23.23,0,0,1,263.87,393.91Zm0-4.1a.67.67,0,0,0-.39.35c-.36.71.08,2.23.41,3.08.55-.94.95-2.69.59-3.29-.07-.11-.19-.24-.51-.17Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.9 406.52 216.4 406.07 217.95 383.64 208.45 384.09 206.9 406.52",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,404.45l-10.76-.34a.68.68,0,0,0-.73.63l-.79,8.49A1.71,1.71,0,0,0,206,415c3.75.05,5.54-.11,10.27,0,2.91.09,8.64.52,12.63,0s3.38-4.43,1.64-4.58c-4.11-.33-9.62-3.17-12.25-5.38A2.65,2.65,0,0,0,216.62,404.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,406.22a12.12,12.12,0,0,1-2.54-.42.22.22,0,0,1-.07-.4c.31-.21,3.08-2,4.24-1.48a.85.85,0,0,1,.5.65,1.23,1.23,0,0,1-.32,1.2A2.52,2.52,0,0,1,220,406.22Zm-1.92-.73c1.7.4,3,.39,3.43,0a.81.81,0,0,0,.18-.8.41.41,0,0,0-.24-.32C220.79,404.07,219.17,404.82,218,405.49Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.47,405.81a.23.23,0,0,1-.11,0,.24.24,0,0,1-.11-.19c0-.11-.13-2.87.86-3.77a1.08,1.08,0,0,1,1-.28.85.85,0,0,1,.79.7c.18,1.05-1.31,3-2.28,3.54A.2.2,0,0,1,217.47,405.81ZM218.9,402a.64.64,0,0,0-.49.18c-.59.53-.72,2.11-.72,3,.85-.68,1.85-2.17,1.73-2.86,0-.13-.1-.28-.42-.33Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.45 384.09 217.96 383.64 217.06 396.47 207.59 396.46 208.45 384.09",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.75,275.93S233.15,287,232,303.67c-2.07,30-12.13,88.63-12.13,88.63l-14.26.2s-3.37-60.14,2-82.06c-17.81,0-68.05-.62-74.9-9.77-7.58-10.11.21-26,.21-26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.93 393.62 221.19 393.35 222.04 384.23 203.1 384.97 203.93 393.62",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,199.5c-5.83-1.14-32.12-.81-32.12-.81A10.5,10.5,0,0,0,130.66,208c-.92,8.11,4.23,26.23,4.41,35.47.22,11.35-1.95,15.95-2.17,31.23L183.07,277c0-30.73-1.34-56.17-2.55-68.37C180.09,204.34,179.33,200.63,173.5,199.5Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,199.5c-5.83-1.14-32.12-.81-32.12-.81A10.5,10.5,0,0,0,130.66,208c-.92,8.11,4.23,26.23,4.41,35.47.22,11.35-1.95,15.95-2.17,31.23L183.07,277c0-30.73-1.34-56.17-2.55-68.37C180.09,204.34,179.33,200.63,173.5,199.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.37,209.18c1.57,5.4,3.15,10.95,4.78,16.37s3.3,10.87,5.18,16c.46,1.31,1,2.53,1.44,3.79l.77,1.77.1.22,0,.11,0,.06v0l0-.07a3.78,3.78,0,0,0-.64-.84c-.34-.33-.47-.36-.5-.36a2.49,2.49,0,0,0,.76.47,12.43,12.43,0,0,0,1.51.61c1.13.39,2.4.74,3.69,1.09,5.23,1.33,10.94,2.35,16.5,3.54l-.18,6.93a85,85,0,0,1-9,.73,80.17,80.17,0,0,1-9.14-.17,43,43,0,0,1-4.82-.62c-.84-.16-1.71-.36-2.65-.63a14.7,14.7,0,0,1-3.2-1.32,10.37,10.37,0,0,1-2.2-1.69,8.25,8.25,0,0,1-1.28-1.72l-.34-.63-1.13-2.14c-.66-1.4-1.38-2.81-2-4.2-1.23-2.81-2.31-5.59-3.39-8.38s-2-5.58-2.93-8.38c-1.85-5.63-3.52-11.2-5-17Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.12,203.61c6.86-7,15.63-3.18,19.4,9.46s3.09,13.56,3.09,13.56l-18.43,7.15C165.83,221.74,159.1,210.74,166.12,203.61Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.86,249.26l-1.47-.13c-4.18,0-4.89,1.14-7.46,3.53l-1,5.26c6.75,3.45,10.37-.34,10.37-.34h6.26l-2.21-5A5.48,5.48,0,0,0,218.86,249.26Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.55,
    y: 304.87,
    width: 69.18,
    height: 9.22,
    rx: 2.55,
    transform: "translate(334.28 618.97) rotate(180)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.39 416.75 132.55 416.75 135.82 314.09 139.75 314.09 135.39 416.75",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.39 416.75 132.55 416.75 135.82 314.09 139.75 314.09 135.39 416.75",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.51 416.75 164.35 416.75 161.09 314.09 157.16 314.09 161.51 416.75",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.51 416.75 164.35 416.75 161.09 314.09 157.16 314.09 161.51 416.75",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.77 416.75 169.93 416.75 173.2 314.09 177.13 314.09 172.77 416.75",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.77 416.75 169.93 416.75 173.2 314.09 177.13 314.09 172.77 416.75",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.89 416.75 201.73 416.75 198.47 314.09 194.54 314.09 198.89 416.75",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.89 416.75 201.73 416.75 198.47 314.09 194.54 314.09 198.89 416.75",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "135.82 314.09 139.75 314.09 139.56 318.45 135.68 318.45 135.82 314.09",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.22 318.45 157.34 318.45 157.16 314.09 161.08 314.09 161.22 318.45",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.12 314.09 176.94 318.45 173.06 318.45 173.2 314.09 177.12 314.09",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.61 318.45 194.72 318.45 194.54 314.09 198.47 314.09 198.61 318.45",
    style: {
      fill: "#2F8DE4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Telecommuting--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389,188.61H228.83a9,9,0,0,1-9.07-9.65l6.11-101.37a10.42,10.42,0,0,1,10.24-9.65H396.24a9,9,0,0,1,9.07,9.65L399.19,179A10.41,10.41,0,0,1,389,188.61Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.26 167.18 265.03 217.71 308.85 167.18 250.26 167.18",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.19,147.82H291.43a5.05,5.05,0,0,1-5.09-5.41l3.43-56.82a5.84,5.84,0,0,1,5.74-5.41h89.76a5,5,0,0,1,5.09,5.41l-3.43,56.82A5.84,5.84,0,0,1,381.19,147.82Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.17,172.33H243.4a5.05,5.05,0,0,1-5.08-5.41l3.43-56.82a5.84,5.84,0,0,1,5.73-5.41h89.77a5,5,0,0,1,5.08,5.41l-3.43,56.82A5.84,5.84,0,0,1,333.17,172.33Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.21,76.76a3.08,3.08,0,0,1-2.87,3,2.6,2.6,0,0,1-2.44-3,3.1,3.1,0,0,1,2.87-3A2.6,2.6,0,0,1,242.21,76.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,76.76a3.09,3.09,0,0,1-2.87,3,2.6,2.6,0,0,1-2.45-3,3.1,3.1,0,0,1,2.87-3A2.61,2.61,0,0,1,252,76.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,76.76a3.08,3.08,0,0,1-2.87,3,2.6,2.6,0,0,1-2.44-3,3.1,3.1,0,0,1,2.87-3A2.6,2.6,0,0,1,261.86,76.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.76,187.67H227.63a9.27,9.27,0,0,1-9.32-9.92l6.12-101.37a10.66,10.66,0,0,1,10.48-9.89H395a9.27,9.27,0,0,1,9.32,9.92l-6.11,101.37A10.67,10.67,0,0,1,387.76,187.67ZM234.91,67a10.15,10.15,0,0,0-10,9.42l-6.12,101.37a8.75,8.75,0,0,0,8.82,9.39H387.76a10.16,10.16,0,0,0,10-9.42l6.11-101.37A8.77,8.77,0,0,0,395,67Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05,128.41c-.68,1.44-1.3,2.67-2,4s-1.4,2.53-2.12,3.78c-1.47,2.49-3,5-4.64,7.34q-1.24,1.8-2.54,3.57c-.91,1.16-1.77,2.34-2.74,3.47a70.23,70.23,0,0,1-6.11,6.64c-.55.54-1.15,1-1.73,1.57a19.44,19.44,0,0,1-1.82,1.51l-1.92,1.45-.59.41a8,8,0,0,1-.81.45,8.16,8.16,0,0,1-1.72.6,8.12,8.12,0,0,1-6.81-1.48,8.54,8.54,0,0,1-1.29-1.26l-.27-.36-.13-.18-.05-.08-.18-.32-.72-1.3c-.22-.42-.37-.82-.55-1.23a32.39,32.39,0,0,1-1.54-4.65,62.21,62.21,0,0,1-1.46-8.79,75.88,75.88,0,0,1-.38-8.68,3.45,3.45,0,0,1,6.76-.88l0,.12a127.44,127.44,0,0,0,4.91,15,23.84,23.84,0,0,0,1.55,3c.13.2.26.44.39.61l.38.46.09.12,0,0-.05-.08-.11-.15a3.12,3.12,0,0,0-.54-.55,3.56,3.56,0,0,0-1.36-.68,3.65,3.65,0,0,0-1.51,0,3.48,3.48,0,0,0-.75.25c-.13,0-.24.13-.36.19s-.3.21-.17.1l1.25-1.22c.42-.38.83-.84,1.24-1.28s.83-.87,1.23-1.34A104.94,104.94,0,0,0,280.86,136c1.37-2.23,2.72-4.5,4-6.8l1.93-3.46,1.83-3.38.1-.18a6.9,6.9,0,0,1,12.31,6.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.87,134.43,255,131.64l5.24-5.35a29.91,29.91,0,0,1,4.25,3.83,2.84,2.84,0,0,1-.8,4.49h0A4.13,4.13,0,0,1,259.87,134.43Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.89,125.91l2.65-1.89a1.62,1.62,0,0,1,2.25.34l1.45,1.93L255,131.64l-1.65-3.76A1.62,1.62,0,0,1,253.89,125.91Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.56,123.93a7.43,7.43,0,0,1,5.78-5.15,45.29,45.29,0,0,1,5.89-.9,157.35,157.35,0,0,1,17.89.32c3.12.21,6.31.65,8.85,1.07h.09a5.15,5.15,0,0,1,4.24,5.91c-1.25,7.22-4.92,19.78-5.32,31.63-.53,15.56-.29,24.52-.56,28.27l-40.05-.77C284.58,146.28,288.05,132.54,290.56,123.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.13,118.68H330c-2.68-.44-6-.91-9.33-1.13l-1.78-.1c-1.75,7.24-12.18,19.42-15.34,37.88-1.22-15.43-2.16-31.56-.37-37.85a79.61,79.61,0,0,0-8.46.71,8.61,8.61,0,0,0-6.34,5.9c-2.46,7.24-7.16,23.46-4.27,63.34h44.51c.29-4-.75-12.4.86-25.33,1.55-12.52,3.78-29.56,5.09-37.17A5.44,5.44,0,0,0,330.13,118.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.6,185.35a.26.26,0,0,1-.27-.24c-.94-11.25.82-27.4.84-27.57a.26.26,0,0,1,.29-.23.27.27,0,0,1,.24.29c0,.16-1.78,16.27-.84,27.46a.26.26,0,0,1-.24.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.56,134.51c-1.65,7.48-.77,17.84,1,27.29,1.31-10.61,3.1-24.38,4.41-32.9C332.14,127.68,329.87,128.54,328.56,134.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.08,117.83c5.19-1.14,6.09-4.34,5.72-7.88a22.49,22.49,0,0,0-.43-2.63l6.48-5.3,4.77-3.88c-1.3,5.74-2.73,16.21,1.19,20.12,0,0-3.2,5.25-12.1,4.61C301.19,122.33,303.08,117.83,303.08,117.83Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.97 121.55 309.53 122.91 314.13 124.64 313.53 122.89 310.97 121.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.49,127.08s-1.81-4.57-3.52-5.54a19,19,0,0,0,8.91-4.93l2.73,1.09S323.47,123,314.49,127.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.45 121.19 309.53 122.91 304.69 123.33 305.66 121.8 308.45 121.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.26,125.79a21.79,21.79,0,0,1,6.19-4.6c-2.63-.78-2.79-4.4-2.79-4.4l-2.55.49S298.43,121.83,302.26,125.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.37,107.31a23,23,0,0,1,.43,2.64c2.42-.44,5.66-3,6-5.45a11.22,11.22,0,0,0,.07-2.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,81.14c-2.32,2.85-2.1,13.16,2.81,13.28S304.72,75.94,300.5,81.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.65,88.64c-.49,7.81-.39,12.4-4.33,16.44-5.92,6.07-15.52,2.58-17.37-5.19-1.65-7-.57-18.59,7.06-21.76A10.53,10.53,0,0,1,321.65,88.64Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.81,82.14c-4.91,4.87,1.47,8.44-1,11.06,4.63,2.42,2.93,4.2,2.93,4.2a6.08,6.08,0,0,0,0,4.12c5.22-1.34,14.91-18.68,4.33-21.34C317.74,83,317.81,82.14,317.81,82.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.82,85.64c-4.65.72-10.5-1.5-14.13-3.38s-4.16,1.67-2.82,2.75c-2.33.08-5.28-1.76-4.55-5.87.67-3.75,5.58-7.3,12.57-4.13,4.95,2.24,11.05-.71,13.43,1.88S322.92,85.15,319.82,85.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,80.55c3.12-.41,3.25-2.38,2.38-5.83,3.37,4.79,2,6.26,0,7.42C323.15,81.39,323,80.55,323,80.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.75,94.63a7.14,7.14,0,0,1-3.41,3.49c-1.93.87-2.91-.91-2.39-3,.47-1.89,2-4.61,4-4.59S324.62,92.7,323.75,94.63Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.46,91c0,.63-.34,1.15-.75,1.16S308,91.65,308,91s.34-1.15.75-1.15S309.46,90.36,309.46,91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,91.06c0,.64-.34,1.15-.76,1.16s-.75-.51-.74-1.15.33-1.15.75-1.15S302.3,90.43,302.3,91.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,91.28a23,23,0,0,1-3,5.46,3.65,3.65,0,0,0,3,.55Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.52,99a5.27,5.27,0,0,0,3.67-2.13.18.18,0,1,0-.31-.2,5.1,5.1,0,0,1-4.1,2,.18.18,0,0,0-.18.19.18.18,0,0,0,.19.18C307.05,99,307.29,99,307.52,99Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.93,88.47a.28.28,0,0,0,.17-.07.36.36,0,0,0,.07-.52,3.68,3.68,0,0,0-3-1.52.36.36,0,0,0-.33.4.39.39,0,0,0,.41.35,2.86,2.86,0,0,1,2.37,1.22A.37.37,0,0,0,312.93,88.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.4,88.78a.37.37,0,0,0,.28-.2,3,3,0,0,1,2.11-1.72.35.35,0,0,0,.31-.42.39.39,0,0,0-.42-.32h0A3.74,3.74,0,0,0,299,88.24a.38.38,0,0,0,.17.5A.45.45,0,0,0,299.4,88.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.76,123.2c1.22,2.57,2.24,5,3.24,7.5s1.89,5.05,2.78,7.6A127.64,127.64,0,0,1,346,154.18c.23,1.39.49,2.75.66,4.18l.13,1.06.07.53,0,.27,0,.37a16.2,16.2,0,0,1,0,3.11,14,14,0,0,1-2.27,6.33,14.19,14.19,0,0,1-4.54,4.25,19,19,0,0,1-4.82,2,25.75,25.75,0,0,1-4.6.82,32.9,32.9,0,0,1-8.79-.35,3.44,3.44,0,0,1-.18-6.75l.36-.08c1-.23,2.31-.51,3.43-.81s2.26-.65,3.32-1a14.8,14.8,0,0,0,5.05-2.8,3.32,3.32,0,0,0,.87-1.32,2.72,2.72,0,0,0,0-1.07,6.73,6.73,0,0,0-.15-.8l-.36-1.63c-.23-1.14-.56-2.32-.86-3.48-.62-2.35-1.32-4.7-2.12-7.06s-1.62-4.71-2.49-7.06-1.79-4.7-2.72-7-1.91-4.72-2.84-6.91l0-.1a6.89,6.89,0,0,1,12.58-5.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.68,172.88,314.27,175l7.62,2.71s5.08-1.62,2.62-4.44l-1.37-.43C320.94,172.12,319.86,172.2,318.68,172.88Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.86,180.38l3.35.64a2.34,2.34,0,0,0,2.46-1.15l1.22-2.19L314.27,175l-1,2.09A2.32,2.32,0,0,0,314.86,180.38Z",
    style: {
      fill: "#ffc3bd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyVideo);
export default __webpack_public_path__ + "static/media/company_video.ac2a3058716146adb47992940a05045f.svg";
export { ForwardRef as ReactComponent };